<template>
<v-window v-model="window" vertical >
  <!-- create -->
  <v-window-item >
    <v-card>
      <v-card-title class='subtitle-1 overline' >
        Add a location
        <v-spacer/>
        <v-btn @click='$emit("close")' v-if='withClose' icon><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-model='location.name'
          @keypress.enter.stop='create'
          label='The name of this location'
          hint='e.g.: Virgin Active Melrose, The Health Center Randburg, etc' />
      </v-card-text>
      <v-card-actions >
        <v-btn @click='$emit("close")' >Cancel</v-btn>
        <v-spacer/>
        <v-btn
          :loading='req.loading'
          :disabled='location.name.length === 0'
          @click='create'
          color='primary' >Create</v-btn>
      </v-card-actions>
    </v-card>
  </v-window-item >

  <!-- edit -->
  <v-window-item >
    <location-edit
      :location='location'
      @close="bubbleClose"
      v-on='$listeners' />
  </v-window-item >
</v-window>
</template>
<script>
import LocationEdit from './LocationEdit.vue'
// import Vue from 'vue'

export default {
  name: 'LocationCreate',
  components: { LocationEdit },
  props: {
    spaceId: { required: true },
    withClose: { type: Boolean, default: true },
    touch: { required: false }
  },
  data () {
    return {
      window: 0,
      location: { id: null, name: '' },
      req: { resource: 'ag.spaces.addresses' }
    }
  },
  watch: {
    createStatus () {
      if (this.createStatus === 201) {
        this.location = this.req.result
        this.window++
        this.$emit('created', this.req.result)
      }
    },
    touch () {
      this.clear()
    }
  },
  computed: {
    payload () {
      return {
        name: this.location.name,
        space: this.spaceId
      }
    },
    createStatus () {
      return this.req.status
    }
  },
  methods: {
    clear () {
      this.location = {name: ''}
      this.window = 0
    },
    create () {
      this.req.data = this.payload
      this.req.kwargs = { spaceId: this.spaceId }
      this.$request('save', this.req)
    },
    bubbleClose () {
      if (this.location && this.location.latitude) {
        this.$emit('close')
      } else {
        window.alert('Please find your location using Google maps before exiting')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// LocationCreate.vue?f0550b88